import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BasketItemComponentDef } from '@df/basket/view/basket-item.component.def';
import { ImageModule } from '@df/module-image/image.module';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../catalog/model/product/product.decorator';
import { LocalBasketItem } from '../customer/basket/basket-item.decorator';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/resut/result.component';
import { BasketBundleOptionsComponent } from './bundle-options/basket-bundle-options.component';
import { ItemQtyComponent } from './item-qty.component';
import { IProductDataV3 } from '@df/catalog/product/product';
import { LocalBasket } from './local-basket';
@Component({
    selector: 'minibasket-item',
    templateUrl: './minibasket-item.html',
    styleUrls: ['./minibasket-item.scss'],
    standalone: true,
    imports: [
        ActionComponent,
        AttributeLabelPipe,
        BasketBundleOptionsComponent,
        ImageModule,
        ItemQtyComponent,
        NgClass,
        OptionLabelPipe,
        PriceComponent,
        ResultComponent,
        RouterLink,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MinibasketItemComponent extends BasketItemComponentDef<LocalBasketItem> {
    @Input()
    noCustomOps: boolean = false;

    declare product?: LocalProduct<IProductDataV3>;

    private localBasket = inject(LocalBasket);
    override get basket() {
        return this.localBasket;
    }

    /**
     * Hides qty selector and remove button for item.
     */
    @Input()
    lock: boolean = false;

    get minQty(): number | undefined {
        return (this.product as LocalProduct)?.minQty;
    }

    get image(): string | undefined {
        return this.item!.data!.am_giftcard_image_url || this.product?.data?.image;
    }
}
